module.exports = __webpack_public_path__ + "static/img/Brisbane-Lions.b80f9e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brisbane-Lions.jpg
// module id = 6kEQ
// module chunks = 1